export default "__VITE_ASSET__238f8ade__"